module.exports = __webpack_public_path__ + "static/welcome-family-e50181997413f990a61ca6a241eda73c.svg";